module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("CONJUNCTIONS")]), _vm._v(" "), _c('h2', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Bi-Annual Volumes of New Writing")]), _vm._v(" "), _c('h3', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('i', [_vm._v("Edited by")])]), _vm._v(" "), _c('h3', {
    staticClass: "center"
  }, [_vm._v("Bradford Morrow")]), _vm._v(" "), _c('h3', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('i', [_vm._v("Contributing Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("John Ashbery")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Martine Bellen")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Mei-mei Berssenbrugge")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Mary Caponegro")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Brian Evenson")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("William H. Gass")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Peter Gizzi")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Robert Kelly")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Ann Lauterbach")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Norman Manea")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Rick Moody")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Howard Norman")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Joan Retallack")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Joanna Scott")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("David Shields")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Peter Straub")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("John Edgar Wideman")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('i', [_vm._v("published by")]), _vm._v(" Bard College")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685d35cf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conjunctions.vue
// module id = 63
// module chunks = 0